/** @jsx $jsx */
import { $jsx } from 'framework7';
function framework7Component(props, {
  $,
  $el,
  $f7,
  $f7route,
  $f7router,
  $h,
  $on,
  $store,
  $theme,
  $update
}) {
  let sampark = [];
  let pratibhavan = [];
  let sortDataTable = function (dataTable, sort) {
    let sortColumn = dataTable.target.dataset.sortColumn;
    let sortOrder = sort;
    let sorted = null;
    if (sortOrder == 'desc') {
      sorted = fastSort.sort(dessertsSorted).desc(dessert => dessert[sortColumn]);
    } else {
      sorted = fastSort.sort(dessertsSorted).asc(dessert => dessert[sortColumn]);
    }
    dessertsSorted = sorted;
    $update();
  };
  let load = async function () {
    console.log("load");
    const response = await $f7.request({
      url: '/api/data',
      method: 'POST',
      data: {
        slug: "mgms-step1",
        timestamp: $f7.getCurrentTimestamp()
      },
      dataType: 'json'
    });
    const data = response.data ?? {};
    sampark = data.data.sampark ?? [];
    pratibhavan = data.data.pratibhavan ?? [];
    console.log(sampark, data);
    $update();
  };
  $on('pageBeforeIn', function () {
    load();
  });
  return function ($ctx) {
      var $ = $ctx.$;
      var $h = $ctx.$h;
      var $root = $ctx.$root;
      var $f7 = $ctx.$f7;
      var $f7route = $ctx.$f7route;
      var $f7router = $ctx.$f7router;
      var $theme = $ctx.$theme;
      var $update = $ctx.$update;
      var $store = $ctx.$store;

      return $h`
  <div class="page" data-name="dashboard">

    <div class="navbar">
      <div class="navbar-bg"></div>
      <div class="navbar-inner">
        <div class="left">
          <a href="#" class="link back">
            <i class="icon icon-back"></i>
            <span class="if-not-md">Back</span>
          </a>
        </div>
        <div class="title">
          Admin Panel
        </div>
      </div>
    </div>

    <div class="page-content">

      <div class="block-title margin-vertical">
        लोगों से संपर्क
      </div>
      <div class="data-table data-table-init data-table-fixed-header card margin-vertical no-shadow" style="max-height: 304px;">
        <table>
          <thead>
            <tr>
              <th class="label-cell">Name</th>
              <th class="numeric-cell">Work</th>
              <th class="numeric-cell">Mobile</th>
            </tr>
          </thead>
          <tbody>
            ${sampark.map((item, index) => $h`
            <tr>
              <td class="label-cell">${item.name}</td>
              <td class="numeric-cell">${item.work}</td>
              <td class="numeric-cell">${item.mobile}</td>
            </tr>
            `)}
          </tbody>
        </table>
      </div>

      <div class="block-title margin-vertical">
        प्रतिभावान
      </div>
      <div class="data-table data-table-init data-table-fixed-header card margin-vertical no-shadow" style="max-height: 304px;">
        <table>
          <thead>
            <tr>
              <th class="label-cell">Name</th>
              <th class="numeric-cell">Work</th>
              <th class="numeric-cell">Mobile</th>
            </tr>
          </thead>
          <tbody>
            ${pratibhavan.map((item, index) => $h`
            <tr>
              <td class="label-cell">${item.name}</td>
              <td class="numeric-cell">${item.work}</td>
              <td class="numeric-cell">${item.mobile}</td>
            </tr>
            `)}
          </tbody>
        </table>
      </div>

    </div>

  </div>
`
    }
    ;
}
framework7Component.id = '16eee32baf';
export default framework7Component;